import { Category } from "pages/vendor/Categories/Categories"
import React from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import CategoryActionMenu from "./Components/CategoryActionMenu"
import { useTranslation } from "react-i18next"

interface ProductCardProps {
  category: Category
  viewDetailsHandler: (id: number) => void
  editCategoryHandler: (category: Category) => void
  deleteCategoryHandler: (category: Category) => void
  toggleActiveCategory: (category: Category) => void
  addOfferHandler: (category: Category) => void
  addCompaign: (category: Category) => void
}

const ProductCard: React.FC<ProductCardProps> = ({
  category,
  deleteCategoryHandler,
  editCategoryHandler,
  toggleActiveCategory,
  viewDetailsHandler,
  addOfferHandler,
  addCompaign,
}) => {
  const { t, i18n } = useTranslation()
  const isArabic = i18n.language === "ar"

  return (
    <Col xxl="3" xl="4" sm="6">
      <Card className="text-center shadow-md rounded-3">
        <CardBody className="p-0">
          <div className="card-body p-2 px-3">
            <div className="d-flex justify-content-between align-items-start p-2">
              <div className="d-flex justify-content-between align-items-start w-100">
                <div className="text-start">
                  <h6 className="mb-0 fw-bold">
                    {isArabic ? category.aR_NAME : category.eN_NAME}
                  </h6>
                  <small className="text-muted">
                    {"__"}
                  </small>
                </div>
                <CategoryActionMenu
                  category={category}
                  editCategoryHandler={editCategoryHandler}
                  viewDetailsHandler={viewDetailsHandler}
                  deleteCouponHandler={deleteCategoryHandler}
                  addOfferHandler={addOfferHandler}
                  addCompaign={addCompaign}
                />
              </div>
              <i className="bi bi-three-dots-vertical"></i>
            </div>

            <div className="p3 px-2">
              <div className="d-flex justify-content-between mt-3">
                <span className="fw-bold">
                  {t("categories_productCount")}: {category.productCount}
                </span>
              </div>
            </div>
            <div className="form-check form-switch mt-3">
              <input
                type="checkbox"
                className="form-check-input"
                id={`customSwitch${category.id}`}
                checked={category.iS_ACTIVE}
                onClick={() => toggleActiveCategory(category)}
                onChange={e => {
                  e.stopPropagation()
                }}
              />
              <label
                className="form-check-label text-capitalize"
                htmlFor={`customSwitch${category.id}`}
              >
                {category.iS_ACTIVE ? "Active" : "Inactive"}
              </label>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

interface ProductsGridProps {
  categorys: Category[]
  viewDetailsHandler: (id: number) => void
  editCategoryHandler: (category: Category) => void
  deleteCategoryHandler: (category: Category) => void
  toggleActiveCategory: (category: Category) => void
  addOfferHandler: (category: Category) => void
  addCompaign: (category: Category) => void
}

export const CategoriesGrid: React.FC<ProductsGridProps> = ({
  categorys,
  deleteCategoryHandler,
  editCategoryHandler,
  toggleActiveCategory,
  viewDetailsHandler,
  addOfferHandler,
  addCompaign,
}) => {
  return (
    <Row>
      {categorys.map(category => (
        <ProductCard
          key={category.id}
          category={category}
          deleteCategoryHandler={deleteCategoryHandler}
          editCategoryHandler={editCategoryHandler}
          toggleActiveCategory={toggleActiveCategory}
          viewDetailsHandler={viewDetailsHandler}
          addOfferHandler={addOfferHandler}
          addCompaign={addCompaign}
        />
      ))}
    </Row>
  )
}
